import { Segment, Header } from 'semantic-ui-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import loadable from '@loadable/component';
const YouTubeLatestVideo = loadable(() => import('./YouTubeLatestVideo'), {ssr: false});


const View = (props) => { 
  const { data, mode, content } = props;

  return (
    <Segment as="section" className="bg-white px-0 liveSection d-print-none" basic>
      <div className="py-5">
        {data?.title ? (
          <Header className='mb-2 headline' as="h2">{data.title}</Header>
          ) : (
          <Header className='visually-hidden' as="h2"><FormattedMessage id="Matadepera en directe" defaultMessage="Matadepera en directe" /></Header>
        )}

        <YouTubeLatestVideo />
        
      </div>
    </Segment>
  );
};

export default injectIntl(View);